var _a;
import { WidgetAuthErrorEnum } from 'src/app/widget-auth/models/widget-auth-error.enum';
// default config
export var defaultAuthErrorConfig = {
    title: 'Your BioDigital Human embed requires proper authentication.',
    description: ''
};
// custom user defined messages based on auth error type
export var authErrorConfig = (_a = {},
    _a[WidgetAuthErrorEnum.InvalidUAID] = {
        title: 'Authentication Issues',
        description: 'Your Human Widget has invalid user credentials.',
        url: 'https://support.biodigital.com'
    },
    _a);
